import React from 'react';
import ctaCteLogo from '../assets/ctacte/logoCtaCte.png';

const PaymentRequired = ({ info, onRetry, onBack, isRetrying }) => {
  const monto = info?.monto != null ? new Intl.NumberFormat('es-AR').format(info.monto) : null;

  return (
    <>
      <div className="form-logos-container">
        <img
          src={ctaCteLogo}
          alt="CtaCte App"
          className="form-logo brand-logo-form"
        />
      </div>

      <div className="form-header">
        <h2 className="form-title">Pago requerido</h2>
        <p className="form-subtitle">{info?.mensaje}</p>
      </div>

      {monto && (
        <p className="form-subtitle" style={{ textAlign: 'center', fontWeight: 600, marginBottom: '1.5rem' }}>
          {monto} {info.moneda} / mes
        </p>
      )}

      <div className="login-form">
        {info?.checkoutUrl ? (
          <a
            className="login-button"
            href={info.checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Ir a pagar con MercadoPago</span>
            <i className="fas fa-arrow-up-right-from-square"></i>
          </a>
        ) : (
          <p className="form-subtitle" style={{ textAlign: 'center' }}>
            No se pudo generar el link de pago. Contactá al administrador.
          </p>
        )}

        <button
          type="button"
          className={`login-button ${isRetrying ? 'loading' : ''}`}
          onClick={onRetry}
          disabled={isRetrying}
        >
          <span>{isRetrying ? 'Verificando...' : 'Ya pagué, reintentar'}</span>
        </button>

        <button
          type="button"
          onClick={onBack}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--gray-600)',
            cursor: 'pointer',
            textAlign: 'center',
            padding: '0.5rem'
          }}
        >
          Volver al inicio de sesión
        </button>
      </div>
    </>
  );
};

export default PaymentRequired;
